import { ContentObserver } from '@angular/cdk/observers';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent  {
  constructor() { }
  @Output() sendDataToParent: any = new EventEmitter();
  @Input({ required: true }) datasource: any
  @Input({ required: true }) total_data_length: any;
  @Input({ required: true }) pageSize = 0;
  @Input({ required: true }) currentPage = 0;




  pageSizeOptions = [10, 20, 50, 100];
  maxSize = 2;

  firstLastButtons = true;
  nextPreviousButtons = true;
  small = false;

  totalPagesCount = 0;
  visiblePages: number[] = [];

  data: any = 0
  ngOnChanges() {
    this.data = this.datasource?.data?.length ?? 0;
    this.updatePagination();
  }

  updatePagination() {
    this.totalPagesCount = Math.ceil(this.total_data_length / this.pageSize) || 1;
    const pages: number[] = [];
    const start = Math.max(1, this.currentPage - this.maxSize);
    const end = Math.min(this.totalPagesCount, this.currentPage + this.maxSize);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    this.visiblePages = pages;
  }

  dataToParent(pageSize: any, currentPage: any) {
    this.sendDataToParent.emit({ pageSize, currentPage });
  }

  onPageSizeChange(event: any) {
    this.pageSize = event.value;
    this.updatePagination();
    if (this.totalPagesCount <= this.currentPage) {
      this.currentPage = 1;
    }
    this.dataToParent(this.pageSize, this.currentPage);
    this.updatePagination();
  }

  selectPageNumber(pageNumber: number) {
    this.currentPage = pageNumber;
    this.dataToParent(this.pageSize, this.currentPage);
    this.updatePagination();
  }

  next() {
    const nextPage = this.currentPage + 1;
    nextPage <= this.totalPagesCount && this.selectPageNumber(nextPage);
  }

  previous() {
    const previousPage = this.currentPage - 1;
    previousPage >= 1 && this.selectPageNumber(previousPage);
  }
}
